<template>
  <BaseBadge
    :aria-label="tooltipText"
    :class="
      twMerge(
        props.productType === 'social' ? 'tw:bg-purple-500' : 'tw:bg-denim-900',
        'tw:rounded-full! tw:size-6.5 tw:p-0! tw:justify-center tw:font-bold',
        props.class
      )
    "
    :label="label"
  >
    <BaseStreemTooltip>{{ tooltipText }}</BaseStreemTooltip>
  </BaseBadge>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";

import BaseBadge from "../BaseBadge";
import BaseStreemTooltip from "../BaseStreemTooltip";

interface BaseProductBadgeProps {
  class?: string;
  productType: "monitoring" | "social";
}

const props = withDefaults(defineProps<BaseProductBadgeProps>(), {
  class: undefined,
});

const tooltipText = computed<string>(() =>
  props.productType === "social"
    ? getLocaleText("social_product_short_name")
    : getLocaleText("monitoring_product_name")
);

const label = computed<string>(() => tooltipText.value[0] ?? "");
</script>
